import * as React from 'react'
import Box from '@mui/material/Box'
import { styled } from '@mui/material/styles'
import { StepIconProps } from '@mui/material/StepIcon'

const StepIconRoot = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isCompletedOrActive'
})<{ isCompletedOrActive: boolean }>(({ theme, isCompletedOrActive }) => ({
  color: theme.palette.common.white,
  display: 'flex',
  height: 32,
  width: 32,
  backgroundColor: isCompletedOrActive ? theme.palette.primary.main : theme.palette.grey[400],
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: 10
}))

const VendorWizardStepIcon: React.FC<StepIconProps> = ({
  active = false,
  completed = false,
  icon
}) => {
  return <StepIconRoot isCompletedOrActive={completed || active}>{icon}</StepIconRoot>
}

export default VendorWizardStepIcon
